module.exports = __webpack_public_path__ + "static/media/05_tearsofhair.57d33196.jpg";